import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GoogleFormsService {

  constructor(private http: HttpClient) { }

  postEmailToForm(emailAddress: string): Observable<any> {
    console.log(emailAddress);
    const url = `https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/d/1ts7cTtb-wZ6a2ZhZ5lk5eSgUE2GrevdZbwlOg3JpisA/formResponse?emailAddress=${emailAddress}`;
    return this.http.post(url, {}, {headers: new HttpHeaders({'Content-Type': 'text/html'})});
  }

  postReferralToForms(name: string, phone: string, email: string): Observable<any> {
    const url = `https://cors-anywhere.herokuapp.com/https://docs.google.com/forms/d/15uip533toR415wioiZXeCZPWIDeilKwNEAQilibeQcg/formResponse?entry.1371191637=${name}&entry.1352228601=${phone}&entry.31713680=${email}`;
    return this.http.post(url, {}, {headers: new HttpHeaders({'Content-Type': 'text/html'})});
  }
}
